<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getCurrentInstance, onMounted } from 'vue';

import TheSearch from '@/components/mode-list/TheSearch.vue';
import { i18n } from '@/shared-instance';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';

i18n.install(getCurrentInstance()!.appContext.app);
const configurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(configurationStore);

// REFACTOR TO WATCHER ?
onMounted(() => {
  if (globalConfiguration.value) {
    const modeDetailComponent = document.querySelector('yb-details');
    if (modeDetailComponent)
      modeDetailComponent.setAttribute('prefix-url', globalConfiguration.value?.prefixUrl ?? undefined);
  }
});
</script>

<template>
  <TheSearch />
</template>
